export default {
  API: 'https://community-calculator.herokuapp.com/',
};